import { flow } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { CustomerUser } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { composeProps, createAction, createPropsExtender } from '@mews/framework';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { createBaseEntitySelectors, createEntitiesReducer } from './utils';
import { getCustomerNativeLanguageCode, getCustomerPreferredLanguageCode, getCustomerUserId } from './customers';

export const NAME = 'customerUsers';

const CUSTOMER_USERS_LOADED = prefix('CUSTOMER_USERS_LOADED');

export const setCustomerUsers = (entities: Array<CustomerUser>) => createAction(CUSTOMER_USERS_LOADED, { entities });

export const [getCustomerUsers, getCustomerUsersByIds, getCustomerUsersByOwnerId, getCustomerUser] =
    createBaseEntitySelectors<ApplicationState, CustomerUser, typeof NAME>(moduleSelector, NAME);

export const customerUsersReducer = createEntitiesReducer({
    FETCH_SUCCESS: CUSTOMER_USERS_LOADED,
});

const getCustomerUserByUserIdFromCustomer = composeProps(getCustomerUser, createPropsExtender('id', getCustomerUserId));

const getCustomerUserPreferredLanguageCodeByUserId = flow(
    getCustomerUserByUserIdFromCustomer,
    (state) => state?.preferredLanguageCode
);

const getCustomerUserNativeLanguageCodeByUserId = flow(
    getCustomerUserByUserIdFromCustomer,
    (state) => state?.nativeLanguageCode
);

export const getCustomerUserCultureCode = flow(
    getCustomerUserByUserIdFromCustomer,
    (state) => state?.preferredCultureCode
);

export const getCustomerUserLanguageCode = createSelector(
    getCustomerUserPreferredLanguageCodeByUserId,
    getCustomerPreferredLanguageCode,
    getCustomerUserNativeLanguageCodeByUserId,
    getCustomerNativeLanguageCode,
    (userPrefferedLanguageCode, customerPreferredLanguageCode, userNativeLanguageCode, customerNativeLanguageCode) =>
        userPrefferedLanguageCode ||
        customerPreferredLanguageCode ||
        userNativeLanguageCode ||
        customerNativeLanguageCode
);
